import React from 'react';
import PropTypes from 'prop-types';
import { TRACK_CLICK_VIDEO_PLAY } from '../../../../src/web/utils/dataLayer';
import { unescape } from '../../../../modules/html-escape';

const propTypes = {
  script: PropTypes.string,
  code: PropTypes.string,
  content: PropTypes.string,
  border: PropTypes.bool,
  height: PropTypes.string,
  contentType: PropTypes.string,
  scrollbars: PropTypes.bool,
  isBuilderView: PropTypes.bool.isRequired,
};

const defaultProps = {
  script: undefined,
  code: undefined,
  content: undefined,
  border: undefined,
  height: undefined,
  contentType: undefined,
  scrollbars: undefined,
};

class EmbedContent extends React.Component {
  componentDidMount() {
    const { script, code } = this.props;

    if (!script) {
      return;
    }

    this.script = document.createElement('script');
    this.script.type = 'application/javascript';
    this.script.src = unescape(script);
    this.script.async = true;

    document.body.appendChild(this.script);

    if (!code) {
      return;
    }

    this.script.onload = () => {
      this.code = document.createElement('script');
      this.code.type = 'application/javascript';
      this.code.text = `
        try {
          ${unescape(code)}
        } catch (e) {
          console.error(e);
        }
      `;

      document.body.appendChild(this.code);
    };
  }

  componentWillUnmount() {
    if (this.script) {
      document.body.removeChild(this.script);
    }

    if (this.code) {
      document.body.removeChild(this.code);
    }
  }

  render() {
    const {
      content, contentType, border, scrollbars, height, isBuilderView,
    } = this.props;

    const iframeBorder = border ? '1px solid black' : 'none';
    const iframeHeight = parseInt(height, 10);
    const builderViewPadding = isBuilderView ? 20 : '';

    if (contentType === 'HTML') {
      return (
        <div
          style={{ width: '100%', padding: builderViewPadding }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: unescape(content) }}
          id="readreviews"
          className="pb-no-click"
        />
      );
    }

    return (
      <div
        style={{ paddingTop: 5 }}
        className="pb-no-click"
      >
        <iframe
          title="embed content"
          src={unescape(content)}
          style={{ border: iframeBorder, height: iframeHeight, width: '100%' }}
          scrolling={scrollbars ? 'yes' : 'no'}
          loading="lazy"
          {...TRACK_CLICK_VIDEO_PLAY}
        />
      </div>
    );
  }
}

EmbedContent.propTypes = propTypes;
EmbedContent.defaultProps = defaultProps;

export default EmbedContent;
